import { ConfirmDialog } from "components/ConfirmDialog";

import type { SkillRow } from "./skillsGridColumns";

type DeleteSkillDialogProps = {
  skill: SkillRow | null;
  onClose: () => void;
  onConfirm: (skill: SkillRow) => void;
  deleting: boolean;
};

export function DeleteSkillDialog({ skill, onClose, onConfirm, deleting }: DeleteSkillDialogProps) {
  return (
    <ConfirmDialog
      open={Boolean(skill)}
      onClose={onClose}
      onConfirm={() => (skill ? onConfirm(skill) : undefined)}
      loading={deleting}
      header="Delete skill?"
      info="This permanently removes the skill. This cannot be undone."
      confirmText="Delete"
      resources={skill ? [{ resourceType: "Skill", resourceName: skill.displayName }] : []}
    />
  );
}
